import { triggerDownloadBlob } from '~/helper/download'

/**
 * Opens a given file blob in a new window
 */
export async function openPopup(data: Blob | File, fallbackDownload = 'export.pdf') {
  const newWindow = window.open(undefined, undefined, getPopupFeatures())

  let blob = data
  if (blob instanceof File) {
    const arrayBuffer = await blob.arrayBuffer()
    blob = new Blob([new Uint8Array(arrayBuffer)], { type: 'application/pdf' })
  }

  if (!newWindow) {
    let msg = 'Failed to open window. '
    if (fallbackDownload) {
      triggerDownloadBlob(blob, fallbackDownload)
      msg += `Try to download file instead: ${fallbackDownload}`
    }
    throw Error(msg)
  }

  // Open PDF in a new window
  const url = URL.createObjectURL(blob)
  newWindow.location.replace(url)
  newWindow.onclose = () => URL.revokeObjectURL(url)
  newWindow.onbeforeunload = () => URL.revokeObjectURL(url)
  return null
}

/**
 * Returns for window.open() to create a popup
 */
function getPopupFeatures() {
  // calc popup dimensions
  const halfWidth = window.screen.width / 2
  const halfHeight = window.screen.height / 2

  // calc center of screen location
  const left = window.screen.width / 2 - halfWidth / 2
  const top = window.screen.height / 2 - halfHeight / 2

  return `popup,width=${halfWidth},height=${halfHeight},left=${left},top=${top}`
}
